



export default class tdDialogMix {




    /**
     * VUE Mix - attache this to your component that renders lists
     * @returns {*} The Dialog Controller Mix
     */
    static getControllerMix() {
        return {

            data() {
                return {
                    // this is sent to all dialogs with v-bind, basically all dialogs are watching this same object for changes
                    // and based on the dialogId the appropriate dialog will react
                    tdDialogMixData: this._tdDialogInitialState()
                }
            },

            methods: {
                _tdDialogInitialState() {
                    return {
                        dialogId: '',     // the dialog ID, based on this each dialog will react
                        isVisible: false, // if true, the dialog with the matching dialogId will react to this and show up
                        isEdit: false,    // is a edit dialog?   (also uses editIndex)
                        isInfo: false,    // is an info dialog?
                        isDelete: false,  // is a delete dialog? (also uses editIndex)
                        editIndex: null,  // if we edit or delete an item, this must be set
                        title: '',        // the dialog tile, this will show up in the UI at the top of the modal usually
                        focusOnRef: null, // on what element to focus when the dialog is opened. here you have to pass the ref attribute of the element
                        isLoading: false, // used to disable the OK and/or Cancel buttons
                        meta: {},
                        onOk() {
                            console.log('tdDialogMix -> no Event for onOK');
                        },
                        onAltOk() {
                            console.log('tdDialogMix -> no Event for onAltOK');
                        },
                        onCancel() {
                            console.log('tdDialogMix -> no Event for onCancel');
                        }
                    }
                },


                tdDialogMixIsVisible() {
                    return this.tdDialogMixData.isVisible;
                },


                tdDialogMixShowAdd(options) {
                    this.tdDialogMixData.dialogId = options.dialogId;
                    this.tdDialogMixData.title = options.title;
                    this.tdDialogMixData.focusOnRef = options.focusOnRef;

                    // add meta
                    if (options.meta !== undefined) {
                        this.tdDialogMixData.meta = options.meta;
                    }

                    // assign the callbacks
                    this.tdDialogMixData.onOk = options.onOk;
                    this.tdDialogMixData.onAltOk = options.onAltOk;
                    this.tdDialogMixData.onCancel = options.onCancel;

                    // show the dialog
                    this.tdDialogMixData.isVisible = true; /** @see tdDialogProp.isVisible - all dialogs are watching this, and only the dialog that has a matching tdDialogProp.dialogId in his props will react */
                },



                tdDialogMixShowEdit(options) {
                    this.tdDialogMixData.dialogId = options.dialogId;
                    this.tdDialogMixData.title = options.title;
                    this.tdDialogMixData.focusOnRef = options.focusOnRef;

                    // add meta
                    if (options.meta !== undefined) {
                        this.tdDialogMixData.meta = options.meta;
                    }

                    // custom dialog types
                    this.tdDialogMixData.editIndex = options.editIndex;
                    this.tdDialogMixData.isEdit = true;


                    // assign the callbacks
                    this.tdDialogMixData.onOk = options.onOk;
                    this.tdDialogMixData.onAltOk = options.onAltOk;
                    this.tdDialogMixData.onCancel = options.onCancel;

                    // show the dialog
                    this.tdDialogMixData.isVisible = true; /** @see tdDialogProp.isVisible - all dialogs are watching this, and only the dialog that has a matching tdDialogProp.dialogId in his props will react */

                },


                tdDialogMixShowInfo(options) {
                    this.tdDialogMixData.dialogId = options.dialogId;
                    this.tdDialogMixData.title = options.title;

                    // add meta
                    if (options.meta !== undefined) {
                        this.tdDialogMixData.meta = options.meta;
                    }

                    // custom dialog types
                    this.tdDialogMixData.editIndex = options.editIndex;
                    this.tdDialogMixData.isInfo = true;


                    // assign the callbacks
                    this.tdDialogMixData.onOk = options.onOk;
                    this.tdDialogMixData.onAltOk = options.onAltOk;

                    // show the dialog
                    this.tdDialogMixData.isVisible = true; /** @see tdDialogProp.isVisible - all dialogs are watching this, and only the dialog that has a matching tdDialogProp.dialogId in his props will react */

                },


                tdDialogMixShowDelete(options) {
                    this.tdDialogMixData.dialogId = options.dialogId;
                    this.tdDialogMixData.title = options.title;

                    // add meta
                    if (options.meta !== undefined) {
                        this.tdDialogMixData.meta = options.meta;
                    }

                    // custom dialog types
                    this.tdDialogMixData.editIndex = options.editIndex;
                    this.tdDialogMixData.isDelete = true;

                    // assign the callbacks
                    this.tdDialogMixData.onOk = options.onOk;
                    this.tdDialogMixData.onCancel = options.onCancel;

                    // show the dialog
                    this.tdDialogMixData.isVisible = true; /** @see tdDialogProp.isVisible - all dialogs are watching this, and only the dialog that has a matching tdDialogProp.dialogId in his props will react */
                },



                tdDialogMixCloseAll() {
                    this.tdDialogMixData = this._tdDialogInitialState();
                }




            }
        }
    }


    /**
     * VUE Mix - attache this to all the dialogs
     *  - REQUIERED Props -
     * @VUE-prop tdDialogProp   - the tdDialogMixData object as a prop
     * @VUE-prop tdDialogIdProp - what id to use for this dialog
     *
     *
     * @returns {*}
     */
    static getViewMix() {
        return {
            // @notice! PLEASE make sure that this properties are reactive. WE don't know for sure
            props: {
                tdDialogProp: {}, // all views must get the full tdDialogMixData object as a prop
                tdDialogIdProp: '', // the current dialog id is stored here as a prop. This dialog will only react for tdDialogObjects that are meant for this dialogID (dialogId)


            },

            methods: {

                /**
                 * Returns true if the current dialog is visible
                 * @returns {boolean}
                 */
                tdDialogMixIsVisible() {
                    if (this.tdDialogProp.isVisible === true && this.tdDialogProp.dialogId === this.tdDialogIdProp) {
                        return true;
                    }
                    return false;
                },


                /**
                 * Returns true if the current dialog is an edit dialog. We use this to alter the initial state of the dialog to have the editing data in it
                 * @returns {boolean}
                 */
                tdDialogMixIsEdit() {
                    return this.tdDialogProp.isEdit;
                },


                /**
                 * Returns true if the current dialog is an info dialog.
                 * @returns {boolean}
                 */
                tdDialogMixIsInfo() {
                    return this.tdDialogProp.isInfo;
                },


                /**
                 * Returns the edit index of the item. Usually the items array is in the $store.state and you get the index from that array
                 * @returns int
                 */
                tdDialogMixGetEditIndex() {
                    return this.tdDialogProp.editIndex;
                },


                /**
                 * get the title of the dialog
                 * @returns string
                 */
                tdDialogMixGetTitle() {
                    return this.tdDialogProp.title;
                },

				/**
				 * Check if meta property exists
				 * @param metaPropName
				 * @returns {boolean}
				 */
				tdDialogMixHasMeta(metaPropName) {
                	return this.tdDialogProp.meta.hasOwnProperty(metaPropName);
				},

                /**
                 * @since 18.2.2019 - it now returns null if there is no meta
                 * @param metaPropName
                 * @returns {null}
                 */
                tdDialogMixGetMeta(metaPropName) {
                    if (this.tdDialogMixHasMeta(metaPropName) === false) {
                        //tdLog.kill('tdDialogMixGetMeta - you tried to read an invalid meta property: ' + metaPropName)
                        return null;
                    }

                    return this.tdDialogProp.meta[metaPropName];

                },


                /**
                 * Useful when you want to change the title of a dialog from whiting
                 */
                tdDIalogMixSetTitle(newTitle) {
                    this.tdDialogProp.title = newTitle;
                },

                /**
                 * Get loading status
                 * @returns bool
                 */
                tdDIalogMixGetLoading() {
                    return this.tdDialogProp.isLoading;
                },


                /**
                 * Set loading status
                 * @status - bool
                 */
                tdDIalogMixSetLoading(status) {
                    this.tdDialogProp.isLoading = status;
                },

                /**
                 * Runs the OK callback
                 */
                tdDialogMixOnOkCallback(params) {
                    this.tdDialogProp.onOk(params);
                    this.tdDialogProp.isLoading = false;
                },

                tdDialogMixOnAltOkCallback(params) {
                    this.tdDialogProp.onAltOk(params);
                    this.tdDialogProp.isLoading = false;
                },

                /**
                 * Runs the Cancel callback
                 */
                tdDialogMixOnCancelCallback() {
                    this.tdDialogProp.onCancel();
                }

            },
            watch: {
                'tdDialogProp.isVisible': function (isVisible) {
                    if (this.tdDialogMixIsVisible()) {

                        // call the onShow "event" when the dialog is shown
                        // we use this instead of create because some dialogs are never destroyed, only hidden
                        if (typeof this.tdDialogMix_onShow === "function") {
                            this.tdDialogMix_onShow();
                        }



                        // do not focus on delete or info dialogs!
                        if (this.tdDialogProp.isDelete === false && this.tdDialogProp.isInfo === false) {

                            // focus on the element based on the ref attribute (strange vue shit)
                            let vm = this;
                            this.$nextTick(function () { // register a nextTick callback to make sure that the element is rendered when we try to focus
                                if (vm.$refs[vm.tdDialogProp.focusOnRef] !== undefined) {
                                    if (Array.isArray(vm.$refs[vm.tdDialogProp.focusOnRef])) {
                                        //on v-for we get an array, focus on 1st element
                                        vm.$refs[vm.tdDialogProp.focusOnRef][0].focus();
                                    } else {
                                        vm.$refs[vm.tdDialogProp.focusOnRef].focus();
                                    }
                                }

                            });
                        }


                    }
                }


            },



        }
    }
}



// WEBPACK FOOTER //
// ./src/tdDialogMix.js